const baseURL = 'users';
export const userPages = {
	root: { base: () => { return '';}, url: baseURL },
	dashboard: { base: () => { return `/${baseURL}`;}, url: '' },
	stammDaten: { base: (username: string) => { return `/${baseURL}/${username}/profile`;}, url: ':username/profile' },
	edit: { base: (username: string) => { return `/${baseURL}/${username}/edit`;}, url: ':username/edit' },
	projectRoles: { base: (username: string) => { return `/${baseURL}/${username}/roles`;}, url: ':username/roles' },
	create: { base: () => { return `/${baseURL}/create`;}, url: ':create' },
};
